import { reactRoute } from '../../../utils/routing/reactRoute'
import { InvoiceBillingStage } from '../enums/invoiceBillingStage'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from './getInvoiceDocumentRouteBase'

export const getInvoiceDraftEditRoute = (
  billingStage: InvoiceBillingStage | undefined,
  documentId: string,
  documentType: InvoiceDocumentType,
): string => {
  if (billingStage === InvoiceBillingStage.Deposit) {
    return reactRoute.organization.invoices.getEditDepositInvoiceDraftRoute(documentId)
  }

  if (billingStage === InvoiceBillingStage.Final) {
    return reactRoute.organization.invoices.getEditFinalInvoiceDraftRoute(documentId)
  }

  return reactRoute.organization.invoices.getEditDocumentDraftRoute(
    getInvoiceDocumentRouteBase(documentType),
    documentId,
  )
}
